import classes from "../forms/forms.module.css";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import { useEffect, useState } from "react";

const InputTextArea = ({ text, placeholder, value, onChange, required }) => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div>
            <label className={classes.label}>
                {text} {required && <b className={classes.required}>*</b>}
            </label>

            <ReactQuill
                theme={width > 1200 ? "snow" : "bubble"}
                placeholder={placeholder}
                className={classes.textarea}
                value={value}
                onChange={onChange}
                style={{
                    height: "200px",
                    maxHeight: "200px",
                    overflowY: "auto"
                }}
            />
        </div>
    );
};

export default InputTextArea;
